define([
    'app/helpers/swiper-start-page',
    'app/helpers/swiper-products',
    'app/helpers/swiper-inspiration',
    'app/helpers/swiper-recently-viewed',
    'app/helpers/grid',
    'app/helpers/helpers',
], function (swiperStartPage, swiperProducts, swiperInspiration, swiperRecentlyViewed, gridHelper, helpers) {
    function IndexController() {
        renderPersonalizedContent();

        function init() {}

        function renderPersonalizedContent() {
            const section = document.getElementById('popular-products');

            fetch('/personalized')
                .then((response) => {
                    if (response.status != 200) {
                        section.innerHTML = '';
                        return;
                    }
                    response.text().then((html) => {
                        section.innerHTML = html;
                        gridHelper.initializeStaticGrid();
                        swiperProducts.create('popular');
                        helpers.initModuleSliderTracking();
                    });
                })
                .catch((error) => {
                    if (typeof Bugsnag !== 'undefined' && Bugsnag && Bugsnag.notify) {
                        Bugsnag.notify('RENDER-ERROR', error);
                    }
                });
        }

        return {
            init: init,
        };
    }

    return IndexController;
});
